export enum ProgrammeCTAType {
  Apply = "Apply",
  ReserveAPlace = "Reserve A Place",
}
